import {
    SET_PARTNER_TYPES,
    SET_USER,
    MANAGE_LOADING_BASE_DATA,
    MANAGE_EDITING_USER } from './mutation-types.js';
    
export default {
    [SET_PARTNER_TYPES](state, payload) {
         state.partnerTypes = payload;
    },
    [SET_USER](state, payload) {
        state.user = payload;
    },
    [MANAGE_LOADING_BASE_DATA](state, payload) {
        state.loadingBaseData = payload;
    },
    [MANAGE_EDITING_USER](state, payload) {
        state.editingUser = payload;
    }
};